import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchBoxModule } from '@jms/ui/ui.search.box';
import { NgSelectModule } from '@ng-select/ng-select';
import { CodeCategoriesComponent, CodeCategoryPickerComponent, CodePickerComponent, CodesComponent, CodeUomPickerComponent, UoMPickerComponent } from './components';


@NgModule({
  imports: [
    CommonModule,
    SearchBoxModule,
    ReactiveFormsModule,
    NgSelectModule,
    ScrollingModule
  ],
  declarations: [
    CodesComponent,
    CodeCategoriesComponent,
    CodePickerComponent,
    CodeCategoryPickerComponent,
    UoMPickerComponent,
    CodeUomPickerComponent
  ],
  exports: [
    CodePickerComponent,
    CodeCategoryPickerComponent,
    UoMPickerComponent,
    CodeUomPickerComponent
  ],
})
export class CodePickerProModule {
  constructor() { }
}
